import { isTablet } from '@/modules/functions';

export class TabLinks {
  list;
  navigation;
  navigationLink;
  mobileLink;
  currentDevice = 'desktop';
  isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

  constructor() {}

  init() {
    this.list = document.querySelector('.tab-links-list');
    if (!this.list) return;

    this.initNavigation();
  }

  initNavigation() {
    this.navigation = document.querySelector('.tab-links-navigation');
    this.navigationLink = document.querySelectorAll('.tab-links-navigation a');
    this.mobileLink = document.querySelectorAll('.tab-links-mobile-link');

    if (!isTablet()) {
      this.addActive(this.navigationLink[0]);
    } else {
      this.currentDevice = 'tablet';
    }

    // Обработка клика по десктопным табам
    this.navigationLink.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        if (!el.classList.contains('active')) {
          this.removeActive();
          this.addActive(el);
        }
      });
    });

    if (!this.isIOS) {
      window.addEventListener('resize', () => this.handleResize());
    }

    this.mobileLink.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        if (!el.classList.contains('active')) {
          this.removeActive();
          this.addActive(el);
        }
      });
    });
  }

  handleResize() {
    if (isTablet() && this.currentDevice !== 'tablet') {
      this.currentDevice = 'tablet';
      this.removeActive();
    } else if (!isTablet() && this.currentDevice !== 'desktop') {
      this.currentDevice = 'desktop';
      this.addActive(this.navigationLink[0]);
    }
  }

  removeActive() {
    this.list.querySelectorAll('.active').forEach((el) => el.classList.remove('active'));
    const activeNav = this.navigation.querySelector('.active');
    if (activeNav) activeNav.classList.remove('active');
  }

  addActive(el) {
    if (!el.classList.contains('active')) el.classList.add('active');
    const target = el.dataset.target;
    if (target) {
      const targetEl = this.list.querySelector(target);
      if (targetEl && !targetEl.classList.contains('active')) {
        targetEl.classList.add('active');
      }
    }
  }
}
